import { CreditCardOutlined } from '@ant-design/icons'
import { Card, Col, Row, Typography } from 'antd'
import Styles from './YendoCard.module.css'

const { Text, Title, Link, Paragraph } = Typography

const YendoCard = () => {
    return (
        <Card bordered={false}>
            <Row justify={'center'} wrap={true}>
                <Col lg={0} className={Styles.border} />
                <Card bordered={false} className={Styles.cardContainer}>
                    <Row justify={'center'} className={Styles.gap15}>
                        <Col span={0} lg={24}>
                            <Row justify={'center'}>
                                <img height={30} alt='Yendo Logo' src="https://assets.cure.com/img/main-site/Orange%20Yendo%20Logo.png" />
                            </Row>
                        </Col>
                        <Row wrap={false} align={'middle'}>
                            <Col>
                                <Row justify={'center'}>
                                    <img height={50} alt='Yendo Logo' src="https://assets.cure.com/img/main-site/Orange%20Credit%20card%20image.png" />
                                </Row>
                            </Col>
                            <Col flex={'15px'} />
                            <Col flex={1}>
                                <Col span={24}>
                                    <Text className={Styles.subTitle}>
                                        Need a credit card?
                                    </Text>
                                </Col>
                                <Col >
                                    <Text className={Styles.text}>
                                        Your CURE-insured vehicle could help you qualify for a secured credit card from Yendo.
                                    </Text>
                                </Col>
                            </Col>
                        </Row>
                        <Col span={24}>
                            <Row justify={'center'}>
                                <Link className={Styles.btnLink} target='_blank' href='/yendo'>
                                    LEARN MORE
                                </Link>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Text className={Styles.small}>
                                Yendo is an independent third-party lender and is not affiliated with CURE auto insurance.
                            </Text>
                        </Col>
                    </Row>
                </Card>
            </Row>
        </Card>
    )
}

YendoCard.propTypes = {}

export default YendoCard